import LoadReactiveSearch from '../components/loadReactiveSearch';

const Header = {
  lastScrollTop: -1,
  scrollTop: window.scrollY,
  header: document.querySelector('#header'),

  // 🔹 Função para atualizar o top do header dinamicamente
  updateHeaderTop: function () {
    const topBar = document.querySelector('.top-bar');
    const header = document.querySelector('#header.home-transparent.page-home');

    if (!topBar || !header) return;

    const topBarPx = topBar.offsetHeight;
    const baseFont = parseFloat(getComputedStyle(document.documentElement).fontSize);
    const topBarRem = topBarPx / baseFont;

    // Aplica top somente se o header tiver a classe on-top
    if (header.classList.contains('on-top')) {
      header.style.top = `${topBarRem}rem`;
    } else {
      header.style.top = '0'; // Volta para top 0 quando a classe on-top não estiver
    }
  },

  setScroll: function (scrollTop, lastScrollTop) {
    const _this = this;
    const topBarExists = document.querySelector('.top-bar'); // verifica se existe

    if (scrollTop <= 0) {
      _this.header.classList.add('scroll-up');
      _this.header.classList.remove('scroll-down');

      // 🔹 Só adiciona on-top se existir top-bar
      if (topBarExists) {
        _this.header.classList.add('on-top');
      }
    } else {
      _this.header.classList.remove('on-top');

      if (scrollTop > lastScrollTop) {
        _this.header.classList.add('scroll-down');
        _this.header.classList.remove('scroll-up');
      } else {
        _this.header.classList.add('scroll-up');
        _this.header.classList.remove('scroll-down');
      }
    }

    _this.updateHeaderTop();
  },

  searchButton: function () {
    const searchButton = document.querySelector('[data-action="show-form-search"]');
    const searchButtonClose = document.querySelector('[data-action="hide-form-search"]');
    const formSearch = document.querySelector('.header-search');
    const formSearchInput = document.querySelector('.header-search input');
    const ANIMATION_TIMER = formSearch.getAttribute('data-animation-timer') || 350;

    if (!formSearch) return;

    searchButton &&
      searchButton.addEventListener('click', () => {
        formSearch.classList.toggle('-active', !formSearch.classList.contains('-active'));

        if (formSearch.classList.contains('-active')) {
          // focus() depende de elemento visível na tela
          // elemento só é considerado visível após qualquer efeito de animação
          setTimeout(() => {
            formSearchInput && formSearchInput.dispatchEvent(new Event('input'))
            formSearchInput && formSearchInput.focus()
          }, ANIMATION_TIMER)
        }


        if (window.innerWidth > 768) {
          document.addEventListener('scroll', () => {
            formSearch.classList.remove('-active');
          });
        }
      });

    searchButtonClose &&
      searchButtonClose.addEventListener('click', () => {
        formSearch.classList.remove('-active');
      });

    // Desativa o popup de busca - quando necessário
    formSearch.addEventListener('click', (e) => {
      if (e.target.className == 'header-search -active') {
        formSearch.classList.remove('-active');
      }
    });
  },

  init: function () {
    const _this = this;

    _this.setScroll(_this.scrollTop, _this.lastScrollTop);
    _this.searchButton();
    LoadReactiveSearch.init();

    // Atualiza top do header ao carregar a página
    _this.updateHeaderTop();

    // Atualiza o header quando a page recebe scroll
    window.addEventListener('scroll', function () {
      const newSt = window.scrollY;

      _this.setScroll(newSt, _this.lastScrollTop);
      _this.lastScrollTop = newSt;
    });

    // Atualiza top do header ao redimensionar a tela
    window.addEventListener('resize', () => _this.updateHeaderTop());
  },
};

export default Header;
